import { render, staticRenderFns } from "./EmpresaDetail.vue?vue&type=template&id=3e5ecb28&"
import script from "./EmpresaDetail.vue?vue&type=script&lang=js&"
export * from "./EmpresaDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports